export const DATE_TIME_FORMAT = 'dd-MM-yyyy hh:mm aaa';
export const DATE_FORMAT = 'dd-MM-yyyy';

export const DATE_TIME_FORMAT_DB = 'yyyy-MM-dd HH:mm:ss';
export const DATE_FORMAT_DB = 'yyyy-MM-dd';